/// <amd-module name="SuiteCommerce.Blog.ExtCarousel.View"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.Blog.ExtCarousel.View", ["require", "exports", "Backbone", "sc_ext_carousel.tpl", "SuiteCommerce.Blog.ExtCarousel.Slide.View", "SuiteCommerce.Blog.ExtCarousel.Indicator.View", "SuiteCommerce.Blog.ExtCarousel.GestureInterpreter", "SuiteCommerce.Blog.ExtCarousel.DOMHandler", "underscore", "Backbone.CollectionView"], function (require, exports, Backbone_1, extCarouselTemplate, ExtCarousel_Slide_View_1, ExtCarousel_Indicator_View_1, ExtCarousel_GestureInterpreter_1, ExtCarousel_DOMHandler_1, _, BackboneCollectionView) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.ExtCarouselView = void 0;
    var ExtCarouselView = /** @class */ (function (_super) {
        __extends(ExtCarouselView, _super);
        function ExtCarouselView(options) {
            var _this = _super.call(this, options) || this;
            _this.template = extCarouselTemplate;
            _this.swipeThreshold = 45;
            _this.setupModelListener();
            _this.carouselId = new Date().getUTCMilliseconds();
            _this.buildEventsHash();
            return _this;
        }
        ExtCarouselView.prototype.setupModelListener = function () {
            var _this = this;
            this.model.on('change:showIndicators', function () {
                _this.render();
            });
        };
        ExtCarouselView.prototype.buildEventsHash = function () {
            var events = {
                'click [data-action="change-slide"]': 'onIndicatorsUsage',
            };
            events["mouseenter [data-carousel-id=\"" + this.carouselId + "\"] .sc-ext-carousel-slide"] = 'onMouseEnter';
            events["mouseleave [data-carousel-id=\"" + this.carouselId + "\"] .sc-ext-carousel-slide"] = 'onMouseLeave';
            this.events = events;
        };
        Object.defineProperty(ExtCarouselView.prototype, "childViews", {
            get: function () {
                var _this = this;
                return {
                    'Slides.View': function () {
                        if (_this.model.slides.size() > 0) {
                            _this.model.slides.models[0].isActive = true;
                        }
                        return new BackboneCollectionView({
                            childView: ExtCarousel_Slide_View_1.ExtCarouselSlideView,
                            collection: _this.model.slides,
                            childViewOptions: {
                                slideContentView: _this.slideContentView,
                                transition: _this.model.transition,
                            },
                        });
                    },
                    'Indicators.View': function () {
                        return _this.indicatorContentView
                            ? new BackboneCollectionView({
                                childView: ExtCarousel_Indicator_View_1.ExtCarouselIndicatorView,
                                collection: _this.model.indicators,
                                childViewOptions: {
                                    indicatorContentView: _this.indicatorContentView,
                                },
                            })
                            : null;
                    },
                };
            },
            enumerable: false,
            configurable: true
        });
        ExtCarouselView.prototype.onMouseEnter = function () {
            if (this.isAutoPlayAllowed() && this.alternationIntervalId !== null) {
                this.pause();
            }
        };
        ExtCarouselView.prototype.onMouseLeave = function () {
            if (this.isAutoPlayAllowed() && !this.alternationIntervalId) {
                this.cycle();
            }
        };
        ExtCarouselView.prototype.moveToSlide = function (targetIndex) {
            var activeIndex = this.getActiveIndex();
            var isGoingToWrapToRight = activeIndex === this.model.slides.size() - 1 && targetIndex === 0;
            if (targetIndex !== activeIndex) {
                if (targetIndex > activeIndex || isGoingToWrapToRight) {
                    this.transitionToRight(activeIndex, targetIndex);
                }
                else {
                    this.transitionToLeft(activeIndex, targetIndex);
                }
            }
        };
        ExtCarouselView.prototype.transitionToRight = function (current, target) {
            this.DOMHandler.executeSlideTransition({
                current: {
                    index: current,
                    direction: ExtCarousel_DOMHandler_1.Direction.left,
                },
                target: {
                    index: target,
                    direction: ExtCarousel_DOMHandler_1.Direction.right,
                },
            });
            this.changeActiveModel(current, target);
        };
        ExtCarouselView.prototype.transitionToLeft = function (current, target) {
            this.DOMHandler.executeSlideTransition({
                current: {
                    index: current,
                    direction: ExtCarousel_DOMHandler_1.Direction.right,
                },
                target: {
                    index: target,
                    direction: ExtCarousel_DOMHandler_1.Direction.left,
                },
            });
            this.changeActiveModel(current, target);
        };
        ExtCarouselView.prototype.changeActiveModel = function (current, target) {
            this.model.slides.at(current).isActive = false;
            this.model.slides.at(target).isActive = true;
        };
        ExtCarouselView.prototype.getActiveIndex = function () {
            return this.model.slides.findIndex(function (slide) {
                return slide.isActive;
            });
        };
        ExtCarouselView.prototype.getNextIndex = function () {
            var nextIndex = this.getActiveIndex() + 1;
            return this.model.slides.at(nextIndex) ? nextIndex : 0;
        };
        ExtCarouselView.prototype.getPrevIndex = function () {
            var prevIndex = this.getActiveIndex() - 1;
            return this.model.slides.at(prevIndex) && prevIndex >= 0
                ? prevIndex
                : this.model.slides.length - 1;
        };
        ExtCarouselView.prototype.getContext = function () {
            return {
                carouselTitle: this.model.carouselTitle,
                carouselId: this.carouselId,
                slides: this.model.slides,
                transition: this.model.transition,
                showIndicators: this.model.showIndicators,
            };
        };
        ExtCarouselView.prototype.render = function () {
            _super.prototype.render.call(this);
            if (this.model.slides.size() > 1) {
                this.initializeDOMHandler();
                this.initializeGestureInterpretation();
                this.throttleTransitionTriggers();
            }
            return;
        };
        ExtCarouselView.prototype.initializeDOMHandler = function () {
            this.DOMHandler = new ExtCarousel_DOMHandler_1.ExtCarouselDOMHandler({ sourceView: this });
        };
        ExtCarouselView.prototype.initializeGestureInterpretation = function () {
            this.gestureInterpreter = new ExtCarousel_GestureInterpreter_1.ExtCarouselGestureInterpreter({
                context: this,
                targetArea: this.DOMHandler.dragArea,
                dragStartCallback: this.onDrag,
                dragEndCallback: this.onDragEnd,
            });
            this.gestureInterpreter.handleGestures();
        };
        ExtCarouselView.prototype.onDrag = function (vectorX, direction) {
            this.pause();
            if (!this.isDragging) {
                this.lastDraggingDirection = direction;
                this.activeIndexDragging = this.getActiveIndex();
                this.targetIndexDragging = this.getTargetIndexByDirection(direction);
                this.DOMHandler.prepareDragArea(this.activeIndexDragging, this.targetIndexDragging);
                this.isDragging = true;
            }
            if (this.isDragging && direction !== this.lastDraggingDirection) {
                this.lastDraggingDirection = direction;
                this.DOMHandler.cleanDragUtilitiesForSlide(this.targetIndexDragging);
                this.targetIndexDragging = this.getTargetIndexByDirection(direction);
                this.DOMHandler.toggleSelectorOnSlide(this.targetIndexDragging, ExtCarousel_DOMHandler_1.ClassNames.dragStartHelper);
            }
            var vectorXBoundSlide = this.DOMHandler.getVectorXForBoundSlide(direction, this.activeIndexDragging);
            var directionFactor = direction === ExtCarousel_DOMHandler_1.Direction.right ? 1 : -1;
            this.DOMHandler.moveSlideTo({
                vectorX: vectorX,
                index: this.activeIndexDragging,
            });
            this.DOMHandler.moveSlideTo({
                vectorX: vectorXBoundSlide * directionFactor,
                index: this.targetIndexDragging,
            });
        };
        ExtCarouselView.prototype.onDragEnd = function (vectorX, direction) {
            var _this = this;
            this.DOMHandler.prepareEndingDrag(this.activeIndexDragging, this.targetIndexDragging);
            if (Math.abs(vectorX) > this.swipeThreshold) {
                var factorSwipeMovement = direction === ExtCarousel_DOMHandler_1.Direction.right ? -1 : 1;
                this.model.slides.at(this.activeIndexDragging).isActive = false;
                this.model.slides.at(this.targetIndexDragging).isActive = true;
                this.DOMHandler.toggleSelectorOnSlide(this.activeIndexDragging, ExtCarousel_DOMHandler_1.ClassNames.activeSlide);
                this.DOMHandler.toggleSelectorOnSlide(this.targetIndexDragging, ExtCarousel_DOMHandler_1.ClassNames.activeSlide);
                this.DOMHandler.moveSlideTo({
                    index: this.targetIndexDragging,
                    vectorX: 0,
                });
                this.DOMHandler.moveSlideTo({
                    index: this.activeIndexDragging,
                    vectorX: this.DOMHandler.screenWidth * factorSwipeMovement,
                });
            }
            else {
                var factorCanceledMovement = direction === ExtCarousel_DOMHandler_1.Direction.right ? 1 : -1;
                this.DOMHandler.moveSlideTo({
                    index: this.targetIndexDragging,
                    vectorX: this.DOMHandler.screenWidth * factorCanceledMovement,
                });
                this.DOMHandler.moveSlideTo({
                    index: this.activeIndexDragging,
                    vectorX: 0,
                });
            }
            setTimeout(function () {
                _this.DOMHandler.cleanDragUtilities(_this.activeIndexDragging, _this.targetIndexDragging);
                _this.isDragging = false;
            }, ExtCarousel_DOMHandler_1.transitionSpeedDragging);
            this.cycle();
        };
        ExtCarouselView.prototype.getTargetIndexByDirection = function (direction) {
            return direction === ExtCarousel_DOMHandler_1.Direction.right
                ? this.getNextIndex()
                : this.getPrevIndex();
        };
        ExtCarouselView.prototype.throttleTransitionTriggers = function () {
            if (this.DOMHandler) {
                this.onIndicatorsUsage = _.throttle(this.onIndicatorsUsageHandler, this.DOMHandler.transitionDelay);
            }
        };
        ExtCarouselView.prototype.onIndicatorsUsageHandler = function (event) {
            if (!this.DOMHandler.isRunningTransition) {
                this.pause();
                var targetIndex = jQuery(event.currentTarget).data('index');
                this.moveToSlide(targetIndex);
                this.cycle();
            }
        };
        ExtCarouselView.prototype.start = function () {
            this.render();
            this.cycle();
        };
        ExtCarouselView.prototype.cycle = function () {
            var _this = this;
            if (this.isAutoPlayAllowed()) {
                if (this.alternationIntervalId)
                    this.pause();
                this.alternationIntervalId = setInterval(function () { return _this.moveToSlide(_this.getNextIndex()); }, this.model.interval);
            }
        };
        ExtCarouselView.prototype.isAutoPlayAllowed = function () {
            return this.model.autoPlay && this.model.slides.size() > 1;
        };
        ExtCarouselView.prototype.pause = function () {
            if (this.alternationIntervalId) {
                clearInterval(this.alternationIntervalId);
                this.alternationIntervalId = null;
            }
        };
        return ExtCarouselView;
    }(Backbone_1.View));
    exports.ExtCarouselView = ExtCarouselView;
});
